import { Vue, Component } from 'vue-property-decorator';
import { IModalConf } from '@/components/Modal/index.d';
import { ITButton } from '@/components/Button/index.d';

@Component
export default class AllotMixin extends Vue {
  public popVis: boolean = false;

  public allotBtn: ITButton = {
    title: '分 配',
    type: 'primary',
    disabled: true,
    icon: 'share-square-o',
    callback: () => {},
  };

  public removeBtn: ITButton = {
    title: '删 除',
    type: 'primary',
    icon: 'trash-o',
    disabled: true,
    callback: () => this.handleRemoveBtn(),
  }

  /* eslint-disable no-return-assign */
  public allotModalConf: IModalConf = {
    title: '素材分配',
    show: false,
    close: () => (this.allotModalConf.show = false),
  };

  public checkPageData: {[key: string]: Array<string>} = {
    sprites: [],
    sounds: [],
    stages: [],
  };

  public allotListConf: Array<{ name: string, icon: string, callback: Function }> = [{
    name: '商城',
    icon: 'cart-plus',
    callback: () => {},
  }, {
    name: '课程',
    icon: 'graduation-cap',
    callback: () => this.handleAllotCourse(),
  }, {
    name: '公共',
    icon: 'folder-o',
    callback: () => this.handleAllotPublic(),
  }];

  /**
   * @author Terry
   * @description 关闭Pop
   */
  handleColsePop() {
    this.popVis = false;
  }

  /**
   * @author Terry
   * @description 处理分配课程
   */
  handleAllotCourse() {
    this.handleColsePop();
    this.allotModalConf.show = true;
  }

  /**
   * @author Terry
   * @description 处理分配模态框关闭事件
   */
  handleAllotModalClose() {
    this.allotModalConf.show = false;
    this.checkPageData.sprites = [];
    this.checkPageData.sounds = [];
    this.checkPageData.stages = [];
    this.allotBtn.disabled = true;
    this.removeBtn.disabled = true;
  }

  /**
   * @author Terry
   * @description 分配公共素材
   */
  // overwrite
  /* eslint-disable class-methods-use-this */
  handleAllotPublic() {}

  // overwrite
  /* eslint-disable class-methods-use-this */
  handleRemoveBtn() {}
}
